import { convertDateToEpochUTC } from "../../../../helper/DateConverters";

export const defaultFormValues = {
      site: null,
      completedBy: {
        displayName: localStorage.displayName,
        userID: localStorage.userID,
      },
      date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
      tripodChecklist: [
        {
          label: "Is the tripod calibrated and in date?",
          value: null,
          name: "tripodCalibrated",
        },
        {
          label: "Is Safe Working Load Displayed on tripod?",
          value: null,
          name: "safeWorkingLoadDisplayed",
        },
        {
          label: "Are there any sharp edges? Inspect eye bolts for damage",
          value: null,
          name: "sharpEdgesInspected",
        },
        {
          label: "Is there any Visible Damage? Inspect tripod for cracks corrosion of damage.",
          value: null,
          name: "visibleDamageInspected",
        },
        {
          label: "Do the leg locking mechanisms function correctly?",
          value: null,
          name: "legLockingMechanismsFunctioning",
        },
        {
          label: "Are push pins in place and in good conditions?",
          value: null,
          name: "pushPinsInPlace",
        },
        {
          label: "Are foot assemblies in place and in good condition?",
          value: null,
          name: "footAssembliesInPlace",
        }
      ],
      winchChecklist: [
        {
          label:
            "Is the winch calibrated and in date?",
          value: null,
          name: "winchCalibrated",
        },
        {
          label: "Rope Drum Free from Damage",
          value: null,
          name: "ropeDrumFree",
        },
        {
          label: "Winch anchored to firm base & can withstand load?",
          value: null,
          name: "winchAnchored",
        },
        {
          label: "Locking device is free from damage?",
          value: null,
          name: "lockingDeviceFree",
        },
        {
          label: "All mechanical parts are functioning?",
          value: null,
          name: "mechanicalPartsFunctioning",
        },
        {
          label: "Wire rope is not showing any damage or wear?",
          value: null,
          name: "wireRopedamage",
        }
      ],
      safetyHarnessChecklist: [
        {
          label:
            "Is the harness fully intact?",
          value: null,
          name: "harnessIntact",
        },
        {
          label: "Is there any clear damage to the harness?",
          value: null,
          name: "harnessDamage",
        },
        {
          label: "Are there any unintended holes on the harness?",
          value: null,
          name: "unintendedHoles",
        },
        {
          label: "Are any of the straps damaged?",
          value: null,
          name: "strapsDamaged",
        },
        {
          label: "Are all clips/attachment points present?",
          value: null,
          name: "clipsPresent",
        },
        {
          label: "Are there any cracked/bent clips or buckles?",
          value: null,
          name: "crackedBentClips",
        }
      ],
      connectorsChecklist: [
        {
          label:
            "Are any of the connectors Cracked?",
          value: null,
          name: "connectorsCracked",
        },
        {
          label: "Do any of the connectors have sharp edges?",
          value: null,
          name: "connectorsSharpEdges",
        },
        {
          label: "Do any of the connectors have missing parts?",
          value: null,
          name: "connectorsMissingParts",
        },
        {
          label: "Are any of the connectors corroded?",
          value: null,
          name: "connectorsCorroded",
        },
        {
          label: "Are all connectors labelled with Safe Working Load?",
          value: null,
          name: "connectorsSafeWorkingLoad",
        },
        {
          label: "Are any of the connectors bent or distorted?",
          value: null,
          name: "connectorsBentDistorted",
        },
        {
          label: "Do any of the connectors stay open or not lock?",
          value: null,
          name: "connectorsStayOpen",
        },
        {
          label: "Are the connectors suitably clean are free from dirt/grease?",
          value: null,
          name: "connectorsFreeFromDirt",
        }
      ],
      gasMonitorChecklist: [
         {
          label: "Is the gas monitor calibrated and in date?",
          value: null,
          name: "gasMonitorCalibrated",
        },
        {
          label: "Has the gas monitor been checked before use to confirm to faults?",
          value: null,
          name: "gasMonitorCheckedBeforeUse",
        }
      ]
    };